module.exports = __webpack_public_path__ + "img/home_xiangce4.8947b42a.png";